var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showTabs.length > 0
    ? _c(
        "Tabs",
        {
          attrs: { id: "editTabPanel", type: "card" },
          model: {
            value: _vm.defaultProject,
            callback: function ($$v) {
              _vm.defaultProject = $$v
            },
            expression: "defaultProject",
          },
        },
        [
          _vm.showTabs.indexOf("physicalProject") > -1
            ? _c(
                "TabPane",
                { attrs: { label: "体检项目", name: "physicalProject" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%", "margin-bottom": "3px" },
                    attrs: { placeholder: "输入关键字进行过滤", clearable: "" },
                    model: {
                      value: _vm.filterProjectText,
                      callback: function ($$v) {
                        _vm.filterProjectText = $$v
                      },
                      expression: "filterProjectText",
                    },
                  }),
                  _c(
                    "FormItem",
                    {
                      style: {
                        "max-height": _vm.maxHeight,
                        "overflow-y": "auto",
                      },
                      attrs: { "label-width": 0 },
                    },
                    [
                      _c("el-tree", {
                        ref: "projectTree",
                        staticClass: "treeBox",
                        attrs: {
                          data: _vm.projectsTreeData,
                          "show-checkbox": "",
                          "node-key": "id",
                          "filter-node-method": _vm.filterNode,
                          "check-strictly": true,
                          "highlight-current": true,
                          "expand-on-click-node": false,
                        },
                        on: { "check-change": _vm.projectIdsCheck },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ node, data }) {
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "custom-tree-node-content",
                                      },
                                      [_vm._v(_vm._s(node.label))]
                                    ),
                                    _vm.model === "table"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-tree-node-content",
                                          },
                                          [
                                            _vm.localApplicableAgeList &&
                                            _vm.localApplicableAgeList.length >
                                              0
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "margin-left": "15px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              报名展示: "
                                                    ),
                                                    _c("el-switch", {
                                                      attrs: {
                                                        "active-color":
                                                          "#13ce66",
                                                        "active-value": 1,
                                                        "inactive-value": 2,
                                                        "inactive-color":
                                                          "#c0c4cc",
                                                        size: "mini",
                                                        value: data.appShow,
                                                        disabled: _vm.disabled,
                                                      },
                                                      on: {
                                                        change: (val) => {
                                                          _vm.handleProjectsTreeDataChange(
                                                            "appShow",
                                                            data,
                                                            val
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.localApplicableAgeList &&
                                            _vm.localApplicableAgeList.length >
                                              0
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                        attrs: {
                                                          value:
                                                            data.startApplicableAgeId,
                                                          placeholder:
                                                            "适用年龄",
                                                          disabled:
                                                            _vm.disabled,
                                                          clearable: "",
                                                          placement: "top",
                                                          transfer: "",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: (val) => {
                                                            _vm.handleProjectsTreeDataChange(
                                                              "startApplicableAgeId",
                                                              data,
                                                              val
                                                            )
                                                          },
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.localApplicableAgeList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              staticStyle: {
                                                                width: "100px",
                                                              },
                                                              attrs: {
                                                                value:
                                                                  item.value,
                                                                label:
                                                                  item.label,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticStyle: {
                                                          width: "100px",
                                                        },
                                                        attrs: {
                                                          value:
                                                            data.endApplicableAgeId,
                                                          placeholder:
                                                            "适用年龄",
                                                          disabled:
                                                            _vm.disabled,
                                                          clearable: "",
                                                          placement: "top",
                                                          transfer: "",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          change: (val) => {
                                                            _vm.handleProjectsTreeDataChange(
                                                              "endApplicableAgeId",
                                                              data,
                                                              val
                                                            )
                                                          },
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.localApplicableAgeList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              staticStyle: {
                                                                width: "100px",
                                                              },
                                                              attrs: {
                                                                value:
                                                                  item.value,
                                                                label:
                                                                  item.label,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "120px",
                                                    },
                                                    attrs: {
                                                      value: data.projectType,
                                                      placeholder:
                                                        "请选择项目类型",
                                                      disabled: _vm.disabled,
                                                      clearable: "",
                                                      placement: "top",
                                                      transfer: "",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      change: (val) => {
                                                        _vm.handleProjectsTreeDataChange(
                                                          "projectType",
                                                          data,
                                                          val
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.lisProjectTypes,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        staticStyle: {
                                                          width: "120px",
                                                          "z-index": "9999",
                                                        },
                                                        attrs: {
                                                          value: item.value,
                                                          label: item.label,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              [
                                                _vm._v(
                                                  "\n              价格: "
                                                ),
                                                _c("Input", {
                                                  staticStyle: {
                                                    width: "70px",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "请输入价格",
                                                    disabled: _vm.disabled,
                                                  },
                                                  on: {
                                                    "on-keyup": function (
                                                      $event
                                                    ) {
                                                      return _vm.changeinput(
                                                        data,
                                                        "price",
                                                        data.price
                                                      )
                                                    },
                                                    input: (val) => {
                                                      _vm.handleLisProjectsTreeDataChange(
                                                        "price",
                                                        data,
                                                        val
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: data.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        data,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "data.price",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          3255174600
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showTabs.indexOf("lisProject") > -1
            ? _c(
                "TabPane",
                { attrs: { label: "Lis项目", name: "lisProject" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "50%", "margin-bottom": "3px" },
                    attrs: { placeholder: "输入关键字进行过滤", clearable: "" },
                    model: {
                      value: _vm.filterLisProjectText,
                      callback: function ($$v) {
                        _vm.filterLisProjectText = $$v
                      },
                      expression: "filterLisProjectText",
                    },
                  }),
                  _c(
                    "FormItem",
                    {
                      style: {
                        "max-height": _vm.maxHeight,
                        "overflow-y": "auto",
                      },
                      attrs: { "label-width": 0 },
                    },
                    [
                      _c("el-tree", {
                        ref: "lisProjectTree",
                        attrs: {
                          data: _vm.lisProjectsTreeData,
                          "show-checkbox": "",
                          "node-key": "id",
                          "filter-node-method": _vm.filterNode,
                          "check-strictly": true,
                          "highlight-current": true,
                          "expand-on-click-node": false,
                        },
                        on: { "check-change": _vm.lisProjectIdsCheck },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function ({ node, data }) {
                                return _c(
                                  "span",
                                  { staticClass: "custom-tree-node" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "custom-tree-node-content",
                                      },
                                      [_vm._v(_vm._s(node.label))]
                                    ),
                                    _vm.model === "table" &&
                                    data.showCheckbox !== false
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "custom-tree-node-content",
                                          },
                                          [
                                            _c(
                                              "span",
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticStyle: {
                                                      width: "120px",
                                                    },
                                                    attrs: {
                                                      value: data.projectType,
                                                      placeholder:
                                                        "请选择项目类型",
                                                      clearable: "",
                                                      placement: "top",
                                                      transfer: "",
                                                      size: "mini",
                                                      disabled: _vm.disabled,
                                                    },
                                                    on: {
                                                      change: (val) => {
                                                        _vm.handleLisProjectsTreeDataChange(
                                                          "projectType",
                                                          data,
                                                          val
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.lisProjectTypes,
                                                    function (item) {
                                                      return _c("el-option", {
                                                        key: item.id,
                                                        staticStyle: {
                                                          width: "120px",
                                                          "z-index": "9999",
                                                        },
                                                        attrs: {
                                                          value: item.value,
                                                          label: item.label,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "span",
                                              [
                                                _vm._v(
                                                  "\n              价格:\n              "
                                                ),
                                                _c("Input", {
                                                  staticStyle: {
                                                    width: "70px",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    placeholder: "请输入价格",
                                                    disabled: _vm.disabled,
                                                  },
                                                  on: {
                                                    "on-keyup": function (
                                                      $event
                                                    ) {
                                                      return _vm.changeinput(
                                                        data,
                                                        "price",
                                                        data.price
                                                      )
                                                    },
                                                    input: (val) => {
                                                      _vm.handleLisProjectsTreeDataChange(
                                                        "price",
                                                        data,
                                                        val
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: data.price,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        data,
                                                        "price",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "data.price",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              },
                            },
                          ],
                          null,
                          false,
                          3304439693
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }